import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/lib/supabase";
import type { Stat } from "@/lib/types";

export function useStats() {
  const [stats, setStats] = useState<Stat[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data, error: err } = await supabase
        .from("stats")
        .select("*")
        .order("sort_order", { ascending: true });
      if (err) throw err;
      setStats(data ?? []);
    } catch {
      setError("Impossible de charger les chiffres clés.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { stats, loading, error, reload: load };
}